/**
 * 유물 도메인 부트스트래퍼 (S2b) — 유물 카드 그리드 탭 + 상세 팝업 조립 + api{acquireRelic}.
 * 획득(골드 차감·레벨)은 ProgressionCommands, 팝업 표시 데이터는 여기서 조립 (shell 콜백 소거).
 */
import { BigNumber } from "@yjsgames/bignumber";
import { RELIC_DEFS } from "../data/balance.js";
import { RelicTabView } from "../ui/RelicTabView.js";
import { buildRelicData } from "../ui/tabData.js";
import type { RelicDetailData } from "../ui/RelicDetailPopup.js";
import { viewTabHandle } from "@yjsgames/phaser-ui/tab-registry";
import type { DomainBootstrapper, GameBoot } from "./BootTypes.js";

export const relicBoot: DomainBootstrapper = {
  key: "relic",
  install(boot) {
    boot.tabs.registerLazy("relic", {
      mount: () => {
        const { tabContent } = boot.layout;
        const view = new RelicTabView(boot.scene, tabContent.x, tabContent.y, tabContent.width, {
          onOpenDetail: (relicId) => openRelicDetail(boot, relicId),
        });
        return viewTabHandle(view, () => view.update(buildRelicData(boot.ctx.relic())));
      },
    });
    boot.api.register({
      acquireRelic: (relicId) => boot.progression.acquireRelic(relicId),
    });
  },
};

/** 유물 카드 클릭 — 상세 팝업 (현재 레벨·효과·획득 비용). 획득 버튼은 차감 후 팝업 갱신(카드는 invalidate 경유). */
function openRelicDetail(boot: GameBoot, relicId: string): void {
  const screen = boot.screen();
  boot.modals.openRelicDetail({
    screenWidth: screen.width,
    screenHeight: screen.height,
    onAcquire: (id) => {
      boot.progression.acquireRelic(id);
      boot.modals.updateRelicDetail(buildRelicDetail(boot, id));
    },
    onClose: () => boot.modals.closeRelicDetail(),
  });
  boot.modals.updateRelicDetail(buildRelicDetail(boot, relicId));
}

/** 상세 팝업 표시 데이터 — 현재 개수 + 구매 가능 여부. */
function buildRelicDetail(boot: GameBoot, relicId: string): RelicDetailData {
  const def = RELIC_DEFS[relicId];
  const cost = def ? def.cost : 0;
  return {
    relicId,
    count: boot.ctx.relic().count(relicId),
    affordable: boot.ctx.economy().gold.gte(BigNumber.fromNumber(cost)),
  };
}
